<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-col :span="24">
          <div
            class="grid-content bg-purple"
            style="text-align: center;padding-bottom: 10px;font-size: 18px;"
          >
            {{ types[form.type] }}
          </div>
        </el-col>
      </el-row>
      <el-form-item label="标题" prop="title" style="margin-right:15px">
        <el-input
          v-model="form.title"
          placeholder="请输入新闻标题"
          :disabled="isDisabled"
        />
      </el-form-item>
      <el-form-item label="内容" prop="content" style="margin-right:15px">
        <myEditor ref="editor" v-model="form.content" :disabled="false" />
      </el-form-item>
      <el-row v-if="form.type == 2">
        <el-form-item
          label="代开发票协议内容"
          prop="contentTwo"
          style="margin-right:15px"
        >
          <myEditor ref="editor" v-model="form.contentTwo" :disabled="false" />
        </el-form-item>
      </el-row>
    </el-form>
    <div v-if="!isDisabled" slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import myEditor from "@/components/MyEditor";

export default {
  name: "ContractBodyEdit",
  components: {
    myEditor
  },
  data() {
    return {
      types: { 1: "托运人合同", 2: "实际承运人合同" },
      isDisabled: false,
      submitMethod: "post",
      emptyForm: {},
      form: {
        code: "",
        branchCode: "",
        title: "",
        content: "",
        contentTwo: "",
        type: ""
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur"
          }
        ],
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
          {
            min: 1,
            max: 16777215,
            message: "长度在 1 到 16777215 个字符",
            trigger: "blur"
          }
        ],
        contentTwo: [
          {
            required: true,
            message: "请输入代开发票协议内容",
            trigger: "blur"
          },
          {
            min: 1,
            max: 16777215,
            message: "长度在 1 到 16777215 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    init(isDisabled) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.isDisabled = isDisabled;
      this.submitMethod = "post"; // 新增
    },
    // 获取页面信息
    getInfo(code) {
      this.submitMethod = "put"; // 编辑
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.$refs.form.resetFields();
      request({
        url: `/ntocc-basic-api/contractBody/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          request({
            url: "/ntocc-basic-api/contractBody",
            method: this.submitMethod,
            data
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.$emit("fatherEditMethod");
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
